// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--g5XIN","form":"form--C3Uxn","card":"card--YAjl2","cardTitle":"cardTitle--gyK89"};